import React, {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import useFetch, {CachePolicies} from "use-http";
import style from "./addFriendPopup.module.css";
import {Spin} from "antd";
import {LoadingOutlined} from "@ant-design/icons";
import {AppContext} from "src/pages/context/App.context";
import {getNameProfile} from "src/service/util.service";

const MemberProfile = (props: any) => {
  const {
    item,
    close,
    getProfile,
    friend,
    setFound,
  } = props;

  enum REQUEST_STATUS {
    EMPTY,
    NONE,
    HAS_REQUESTED,
    PENDING,
  }

  const addFriend = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/users/add-friend",
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const acceptFriend = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/users/accept-friend",
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const cancelfriend = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/users/cancel-friend",
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );


  const { t } = useTranslation();
  const appCtx: any = useContext(AppContext);

  const [acceptText, setAcceptText] = useState("");
  const [cancelText, setCancelText] = useState("");
  const [isFriend, setIsFriend] = useState(false);
  const [requestStatus, setRequestStatus] = useState(REQUEST_STATUS.EMPTY);


  const connect = async (id: any) => {
    const res = await addFriend.post({ friendID: id });
    console.log("res >>>", res);
    console.log("id ::>>", id);
    if (id === item.id) {
      if (addFriend?.response?.ok) {
        if (res?.type === "request") {
          console.log("profile request");
          setRequestStatus(REQUEST_STATUS.PENDING);
        } else if (res?.type === "accept") {
          appCtx.setNewFriend(item);
          console.log("profile data", item);
          let num = appCtx.friendsNum + 1
          appCtx.setFriendsNum(num);
          setIsFriend(true);
        }
      }
    }
  };

  const genAcceptText = () => {
    if (requestStatus === REQUEST_STATUS.PENDING) {
      setAcceptText("Requested");
    } else if (requestStatus === REQUEST_STATUS.HAS_REQUESTED) {
      setAcceptText("Accept");
    } else if (requestStatus === REQUEST_STATUS.NONE) {
      setAcceptText("Connect");
    }
  };

  const genCancelText = () => {
    if (requestStatus === REQUEST_STATUS.PENDING) {
      setCancelText("Cancel");
    } else if (requestStatus === REQUEST_STATUS.HAS_REQUESTED) {
      setCancelText("Reject");
    } else if (requestStatus === REQUEST_STATUS.NONE) {
      setCancelText("Cancel");
    }
  };

  const cancelRequest = async (id: any) => {
    // console.log("ppopo",id);

    await cancelfriend.post({ friendID: id });
    // console.log("ppopo",response);
    if (cancelfriend.response.ok) {
      // console.log("friendID",friendID);
      getProfile(friend);
    }
  };

  const acceptRequest = async () => {
    await acceptFriend.post({ friendID: item.id });
    if (acceptFriend.response.ok) {
      appCtx.setNewFriend(item);
      setIsFriend(true);
      getProfile(friend);
    }
  };

  const checkStatusID = async () => {
    //เป็นเพื่อนกัน
    if (item.friends.status === "accepted") {
      setFound(true);
      setIsFriend(true);
    }
    //เพื่อนขอมา
    else if (item.friends.status === "pending" && item.friends.type === "request") {
      setRequestStatus(REQUEST_STATUS.HAS_REQUESTED);
    }
    //ขอเป็นเพื่อนรอเพื่อนรับ
    else if (item.friendsAccept.status === "pending" && item.friendsAccept.type === "request") {
      setRequestStatus(REQUEST_STATUS.PENDING);
    } else {
      setRequestStatus(REQUEST_STATUS.NONE);
    }
  }

  useEffect(() => {
    checkStatusID();
  }, [item])

  useEffect(() => {

    genAcceptText();
    genCancelText();
  }, [requestStatus]);

  return (
    <div className={style.personContainer}>
      <div
        className={style.profileImage}
        style={{
          backgroundImage: `url(${item.imageProfileURL})`,
        }}
      />

      <div className={style.name}>{getNameProfile(item.firstname,item.lastname)}</div>
      <label>{item.position}</label>
      <div
        className={style.buttonContainer}
        style={{
          justifyContent:
            isFriend || requestStatus == REQUEST_STATUS.HAS_REQUESTED
              ? "center"
              : "space-between",
        }}
      >
        {isFriend || requestStatus == REQUEST_STATUS.HAS_REQUESTED ? (
          <button
            type="button"
            className={isFriend ? style.disabledBtn : style.connectBtn}
            disabled={isFriend}
            onClick={(event) => {
              acceptRequest();
            }}
          >
            {requestStatus == REQUEST_STATUS.HAS_REQUESTED
              ? t("Accept")
              : t("Connected")}
          </button>
        ) : null}
        {!isFriend && requestStatus != REQUEST_STATUS.HAS_REQUESTED ? (
          <button
            type="button"
            className={
              requestStatus == REQUEST_STATUS.NONE
                ? style.connectBtn
                : style.disabledBtn
            }
            onClick={() => {
              connect(item.id);
            }}
            disabled={requestStatus != REQUEST_STATUS.NONE}
          >
            {!addFriend.loading || !acceptFriend.loading ? (
              t(acceptText)
            ) : (
              <Spin
                indicator={
                  <LoadingOutlined
                    style={{ fontSize: "25px", color: "#FFFFFF" }}
                  />
                }
              />
            )}
          </button>
        ) : null}
        {!isFriend && requestStatus != REQUEST_STATUS.HAS_REQUESTED ? (
          <button
            type="button"
            className={style.cancelBtn}
            onClick={() => {
              if (requestStatus == REQUEST_STATUS.PENDING) {
                cancelRequest(item.id);
              } else {
                close();
              }
            }}
          >
            {t(cancelText)}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default MemberProfile;
